/* Black November: one shared deadline, matching Shopify's native automatic discount. */
(function () {
  'use strict';
  var node = document.getElementById('FnBlackNovemberConfig');
  if (!node) return;
  var config;
  try { config = JSON.parse(node.textContent); } catch (error) { return; }
  var start = Date.parse(config.startsAt), end = Date.parse(config.endsAt);
  if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) return;
  var byId = Object.create(null), byHandle = Object.create(null), entries = new Map();
  (config.products || []).forEach(function (p) {
    byId[p.id.split('/').pop()] = p;
    byHandle[p.handle] = p;
  });
  var money = new Intl.NumberFormat('da-DK', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  var observer, queued = false;
  function active() { var now = Date.now(); return now >= start && now < end; }
  function sold(root) { return root.matches('.is-sold-out,.fn-soeg__res--solgt,.fn-soeg__nrchip--solgt') || !!root.querySelector('.fn-is-sold'); }
  function restore(entry) {
    if (entry.price.isConnected) {
      entry.price.innerHTML = entry.html;
      entry.price.classList.remove('fn-bn-price');
      entry.root.classList.remove('fn-bn-pdp-active', 'fn-bn-preview-active');
      if (entry.anchor) entry.anchor.classList.remove('fn-bn-source');
      if (entry.label !== null) entry.root.setAttribute('aria-label', entry.label);
    }
    entry.badge.remove();
  }
  function decorate(root, price, product, compact) {
    if (!root || !price || !product || sold(root)) return;
    var entry = entries.get(root);
    if (entry && entry.price === price && entry.badge.isConnected && price.classList.contains('fn-bn-price')) return;
    if (entry) { if (entry.price === price) restore(entry); else entry.badge.remove(); entries.delete(root); }
    var badge = document.createElement('span');
    badge.className = 'fn-bn' + (compact ? ' fn-bn--compact' : '');
    var label = document.createElement('span'); label.className = 'fn-bn__label'; label.textContent = 'Black November tilbud';
    var heading = document.createElement('span'); heading.className = 'fn-bn__heading'; heading.appendChild(label);
    var baseCents = Math.round(Number(product.basePrice) * 100), saleCents = Math.round(Number(product.salePrice) * 100);
    var percent = baseCents > 0 ? Math.floor((baseCents - saleCents) * 100 / baseCents + 0.0000001) : 0;
    if (percent > 0 && percent <= 100) {
      var saving = document.createElement('span'); saving.className = 'fn-bn__badge'; saving.textContent = 'Spar ' + percent + ' %'; heading.appendChild(saving);
    }
    var prices = document.createElement('span'); prices.className = 'fn-bn__prices';
    if (Number(product.basePrice) > Number(product.salePrice)) {
      var old = document.createElement('s'); old.className = 'fn-bn__old'; old.textContent = 'kr. ' + money.format(Number(product.basePrice)); old.setAttribute('aria-label', 'Normalpris ' + old.textContent);
      var before = document.createElement('span'); before.className = 'fn-bn__before';
      var beforeLabel = document.createElement('span'); beforeLabel.className = 'fn-bn__before-label'; beforeLabel.textContent = 'Før';
      before.appendChild(beforeLabel); before.appendChild(old); prices.appendChild(before);
    }
    var sale = document.createElement('span'); sale.className = 'fn-bn__sale'; sale.textContent = 'kr. ' + money.format(Number(product.salePrice)); prices.appendChild(sale);
    var tax = document.createElement('span'); tax.className = 'fn-bn__tax'; tax.textContent = 'ekskl. moms';
    var clock = document.createElement('time'); clock.className = 'fn-bn__clock'; clock.dateTime = config.endsAt; clock.setAttribute('aria-live', 'off');
    var captions = compact ? ['dage', 'timer', 'min.', 'sek.'] : ['dage', 'timer', 'minutter', 'sekunder'];
    captions.forEach(function (name, index) {
      var unit = document.createElement('span'); unit.className = 'fn-bn__unit'; unit.setAttribute('aria-hidden', 'true');
      var value = document.createElement('span'); value.className = 'fn-bn__unit-value'; value.dataset.unit = index; value.textContent = '00';
      var caption = document.createElement('span'); caption.className = 'fn-bn__unit-label'; caption.textContent = name;
      unit.appendChild(value); unit.appendChild(caption); clock.appendChild(unit);
    });
    var promise = document.createElement('span'); promise.className = 'fn-bn__promise'; promise.textContent = 'Bliver ikke billigere under Black Friday';
    badge.appendChild(heading); badge.appendChild(prices); badge.appendChild(tax); badge.appendChild(clock); badge.appendChild(promise);
    var anchor = price.closest('.grid-product__price-wrap,.price-wrapper') || price;
    entry = { root: root, price: price, html: price.innerHTML, badge: badge, anchor: anchor, label: root.getAttribute('aria-label') };
    entries.set(root, entry);
    price.textContent = sale.textContent;
    var searchOffer = root.matches('.fn-soeg__res,.fn-soeg__nrchip') && percent > 0;
    if (searchOffer) {
      var amount = document.createElement('span');
      amount.className = 'fn-bn-search-amount';
      amount.textContent = sale.textContent;
      var detail = document.createElement('small');
      detail.append(old.cloneNode(true), ' · Spar ' + percent + ' %');
      amount.appendChild(detail);
      price.replaceChildren(amount);
    }
    price.classList.add('fn-bn-price');
    anchor.classList.add('fn-bn-source');
    if (root.matches('[data-fn-handle]')) root.classList.add('fn-bn-preview-active');
    if (entry.label !== null) root.setAttribute('aria-label', product.title + ', ' + sale.textContent + ', Black November tilbud' + (searchOffer ? ', før ' + old.textContent + ', spar ' + percent + ' procent' : ''));
    anchor.insertAdjacentElement('afterend', badge);
  }
  function scan() {
    if (!active()) return;
    document.querySelectorAll('[data-product-card][data-upsell-target-id]').forEach(function (root) {
      decorate(root, root.querySelector('.grid-product__price'), byId[root.getAttribute('data-upsell-target-id')], true);
    });
    document.querySelectorAll('.fn-soeg__res[data-h],.fn-soeg__nrchip[data-h]').forEach(function (root) {
      decorate(root, root.querySelector('.fn-soeg__pris,.fn-soeg__nrchip-pris'), byHandle[root.getAttribute('data-h')], true);
    });
    document.querySelectorAll('[data-fn-handle]').forEach(function (root) {
      decorate(root, root.querySelector('.fn-kig__pris'), byHandle[root.getAttribute('data-fn-handle')], false);
    });
    var product = byHandle[config.pageHandle], price = document.getElementById('ProductPrice');
    if (product && price) {
      var container = price.closest('[data-price-container]');
      if (container && !document.querySelector('.fn-pdp__sold')) {
        decorate(container, price, product, false);
        container.classList.add('fn-bn-pdp-active');
      }
    }
    entries.forEach(function (entry, root) { if (!root.isConnected) { entry.badge.remove(); entries.delete(root); } });
  }
  function clockText(seconds) {
    var days = Math.floor(seconds / 86400);
    function pad(n) { return String(n).padStart(2, '0'); }
    return days + (days === 1 ? ' dag ' : ' dage ') + pad(Math.floor(seconds % 86400 / 3600)) + ':' + pad(Math.floor(seconds % 3600 / 60)) + ':' + pad(seconds % 60);
  }
  function update() {
    if (observer) observer.disconnect();
    if (active()) {
      scan();
      var seconds = Math.max(0, Math.ceil((end - Date.now()) / 1000));
      var text = clockText(seconds);
      var parts = [Math.floor(seconds / 86400), Math.floor(seconds % 86400 / 3600), Math.floor(seconds % 3600 / 60), seconds % 60];
      entries.forEach(function (entry) {
        var clock = entry.badge.querySelector('time'); clock.setAttribute('aria-label', text);
        clock.querySelectorAll('[data-unit]').forEach(function (value) { var next = String(parts[Number(value.dataset.unit)]).padStart(2, '0'); if (value.textContent !== next) value.textContent = next; });
      });
    } else if (entries.size) {
      entries.forEach(restore); entries.clear();
    }
    if (observer) observer.observe(document.body, { childList: true, subtree: true });
  }
  observer = new MutationObserver(function () {
    if (queued) return;
    queued = true;
    Promise.resolve().then(function () { queued = false; update(); });
  });
  update();
  var timer = setInterval(update, 1000);
  document.addEventListener('visibilitychange', update);
  window.addEventListener('pagehide', function () { clearInterval(timer); observer.disconnect(); });
  window.addEventListener('pageshow', function (event) { if (event.persisted) { update(); clearInterval(timer); timer = setInterval(update, 1000); } });
})();
